module.exports = __webpack_public_path__ + "img/Feature.33bc0069.jpg";